import MobileWarning from '../components/MobileWarning';

function Default(props){
    return(
        <MobileWarning/>
    )
}

export default Default;